module.exports = __webpack_public_path__ + "static/00067.ad8b9f97.jpg";